module.exports = __webpack_public_path__ + "img/couples-085.ae8cd31e.jpg";